import { render } from "./historicHeader.vue?vue&type=template&id=3346bcbc&scoped=true&ts=true"
import script from "./historicHeader.vue?vue&type=script&lang=ts"
export * from "./historicHeader.vue?vue&type=script&lang=ts"

import "./historicHeader.vue?vue&type=style&index=0&id=3346bcbc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3346bcbc"]])

export default __exports__